import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
import { getCampaignColors } from "./normalizeCampaigns";
/** Post details variant (CarMoneyInfoBox). */
var PostDetailsCampaignLabel = function PostDetailsCampaignLabel(_ref) {
  var data = _ref.data,
    type = _ref.type;
  var isFinance = type === "finance";
  var _getCampaignColors = getCampaignColors(data, type),
    bgColor = _getCampaignColors.bgColor,
    txtColor = _getCampaignColors.txtColor;
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex items-center w-full justify-start gap-1 min-w-0 min-h-[24px] overflow-hidden rounded-[2px] py-0.5 px-3", isFinance && "border border-solid border-[#d9e1eb] py-0"),
    style: {
      backgroundColor: bgColor,
      color: txtColor
    }
  }, data.icon ? /*#__PURE__*/React.createElement("img", {
    src: data.icon,
    alt: "",
    className: "shrink-0 object-contain w-5 h-5"
  }) : '', /*#__PURE__*/React.createElement("span", {
    className: "text-[10px] font-bold whitespace-nowrap overflow-hidden text-ellipsis min-w-0 py-0.5",
    dir: "auto"
  }, data.text));
};
export default PostDetailsCampaignLabel;